import { Trans } from '@lingui/react/macro';

import { useCRMAudienceReportMetadata } from '@/api/audience';
import { ReportName } from '@/components/ReportName';
import { Text } from '@/components/typography';

type Props = {
  url?: string;
};

const AudienceDetailEditHubspot = ({ url }: Props) => {
  const {
    reportMetadata,
    isLoading: isReportLoading,
    error: reportError,
  } = useCRMAudienceReportMetadata(url);

  return (
    <div className="flex flex-col gap-4">
      <div>
        <Text variant="body1">
          <Trans>
            <strong>Note: </strong>
            Your HubSpot Companies Segment List must include the standard "
            <strong>Company Domain Name</strong>" field as a column.
          </Trans>
        </Text>
      </div>
      <Text variant="label">
        <Trans>HubSpot Report Link</Trans>
      </Text>
      <Text variant="body1" color="grey">
        {url}
      </Text>
      {
        <ReportName
          reportName={reportMetadata?.name}
          isLoading={isReportLoading}
          error={reportError}
        />
      }
    </div>
  );
};

export default AudienceDetailEditHubspot;
